import { translateDbLabel } from "./translateDbLabel";

// O backend (Inbound-Escotta-Backend) não tem sistema de i18n — as mensagens de
// erro/status que ELE escreve (não as que vêm do SAP dentro de ET_RETURN/ET_BAPI_RET, nem as
// que vêm da SEFAZ, que são texto dinâmico de terceiros e não dá pra traduzir) são strings
// fixas em português espalhadas pelos arquivos de src/service, src/modules e src/middleware.
// Esse dicionário faz a tradução no front, sem precisar mexer no backend: STATIC_MESSAGES é
// lookup exato pras mensagens sem parte dinâmica (a maioria); PATTERNS é regex com grupo de
// captura pras que têm accessKey/CNPJ/mensagem de erro original interpolados.
//
// Mensagem sem match continua em português (não quebra nada) — é só uma questão de completar
// o dicionário quando aparecer uma nova.
const STATIC_MESSAGES = {
  // SEFAZ
  "NF-e não encontrada na base": "NF-e not found in the database",
  "CNPJ destinatário não informado no header": "Recipient CNPJ not provided in the header",
  "UF de origem não informada no header da NF-e": "Origin state (UF) not provided in the NF-e header",
  "Resposta inválida da SEFAZ": "Invalid response from SEFAZ",
  "Produção": "Production",
  "Homologação": "Staging",
  "Empresa não cadastrada": "Company not registered",
  "Certificado digital não configurado para este CNPJ": "Digital certificate not configured for this CNPJ",
  "NF-e não importada — XML recebido mas não salvo": "NF-e not imported — XML received but not saved",
  "NF-e não encontrada": "NF-e not found",
  "CNPJ destinatário não informado": "Recipient CNPJ not provided",
  "Chave privada não encontrada no PFX": "Private key not found in the PFX",
  "Certificado não encontrado no PFX": "Certificate not found in the PFX",

  // Controllers de busca no SAP PI (poController, batchController, depositoController, searchOrderController)
  "CNPJ emitente e destinatário são obrigatórios": "Issuer and recipient CNPJ are required",
  "Campo centro é obrigatório": "Plant is required",

  // Admin — certificados
  "Erro ao buscar certificados": "Error fetching certificates",
  "CNPJ obrigatório": "CNPJ is required",
  "Empresa não encontrada para o CNPJ informado": "Company not found for the given CNPJ",
  "Erro ao salvar certificado": "Error saving certificate",
  "Certificado não encontrado": "Certificate not found",
  "Erro ao excluir certificado": "Error deleting certificate",

  // Admin — CFOP
  "Erro ao buscar CFOPs": "Error fetching CFOPs",
  "CFOP obrigatório": "CFOP is required",
  "CFOP já cadastrado": "CFOP already registered",
  "Processo não encontrado": "Process not found",
  "Erro ao criar CFOP": "Error creating CFOP",
  "CFOP não encontrado": "CFOP not found",
  "Erro ao atualizar CFOP": "Error updating CFOP",
  "CFOP possui NF-e vinculadas": "CFOP has linked NF-e records",
  "Erro ao excluir CFOP": "Error deleting CFOP",

  // Admin — empresas
  "Erro ao buscar empresas": "Error fetching companies",
  "CNPJ já cadastrado": "CNPJ already registered",
  "Erro ao criar empresa": "Error creating company",
  "Empresa não encontrada": "Company not found",
  "Erro ao atualizar empresa": "Error updating company",
  "Empresa possui registros vinculados": "Company has linked records",
  "Erro ao excluir empresa": "Error deleting company",

  // Admin — logs, PI config
  "Erro ao listar logs de integração": "Error listing integration logs",
  "Erro ao buscar funções PI": "Error fetching PI functions",
  "Erro ao buscar configuração PI": "Error fetching PI configuration",
  "Erro ao salvar configuração PI": "Error saving PI configuration",

  // Admin — processos e etapas
  "Erro ao buscar processos": "Error fetching processes",
  "Código do processo obrigatório": "Process code is required",
  "Código de processo já cadastrado": "Process code already registered",
  "Erro ao criar processo": "Error creating process",
  "Erro ao atualizar processo": "Error updating process",
  "Processo possui registros vinculados": "Process has linked records",
  "Erro ao excluir processo": "Error deleting process",
  "Erro ao buscar etapas": "Error fetching steps",
  "Processo e etapa obrigatórios": "Process and step are required",
  "Etapa já cadastrada para este processo": "Step already registered for this process",
  "Erro ao criar etapa": "Error creating step",
  "Etapa não encontrada": "Step not found",
  "Erro ao atualizar etapa": "Error updating step",
  "Erro ao excluir etapa": "Error deleting step",

  // Admin — usuários
  "Erro ao buscar usuários": "Error fetching users",
  "E-mail, nome e perfil são obrigatórios": "Email, name and role are required",
  "Você não pode associar empresas que não são suas": "You cannot associate companies that are not yours",
  "E-mail já cadastrado": "Email already registered",
  "Erro ao criar usuário": "Error creating user",
  "Usuário não encontrado": "User not found",
  "Acesso negado": "Access denied",
  "Não pode atribuir este perfil": "Cannot assign this role",
  "Erro ao atualizar usuário": "Error updating user",
  "Não pode desativar o próprio usuário": "Cannot deactivate your own user account",
  "Erro ao desativar usuário": "Error deactivating user",

  // Admin — XML SEFAZ / NSU
  "Erro na integração SEFAZ": "Error in SEFAZ integration",
  "Erro interno ao consultar SEFAZ": "Internal error querying SEFAZ",
  "Erro ao buscar NSU": "Error fetching NSU",
  "Erro ao resetar NSU": "Error resetting NSU",

  // Autenticação
  "E-mail e senha são obrigatórios": "Email and password are required",
  "Usuário ou senha inválidos": "Invalid user or password",
  "Conta configurada para login SSO. Use o SAP para autenticar.": "Account configured for SSO login. Use SAP to authenticate.",
  "Erro interno ao autenticar": "Internal error while authenticating",
  "refreshToken obrigatório": "refreshToken is required",
  "Sessão expirada. Faça login novamente.": "Session expired. Please log in again.",
  "Usuário inativo": "Inactive user",
  "Erro interno ao renovar sessão": "Internal error renewing session",
  "Erro interno ao encerrar sessão": "Internal error ending session",
  "Erro interno": "Internal error",
  "Token não informado": "Token not provided",
  "Token inválido ou expirado": "Invalid or expired token",
  "Não autenticado": "Not authenticated",
  "Acesso negado para este perfil": "Access denied for this role",
  "Erro interno do servidor": "Internal server error",

  // Upload/salvamento de XML
  "Nenhum documento enviado": "No document uploaded",
  "XML não enviado": "XML not uploaded",
  "Chave de acesso não encontrada no XML": "Access key not found in the XML",
  "Processamento concluído": "Processing completed",
  "Erro ao salvar XML": "Error saving XML",
  "accessKey é obrigatória": "accessKey is required",
  "accesskey é obrigatória": "accessKey is required",
  "Etapa de atribuição de pedido não encontrada para este processo": "Purchase order assignment step not found for this process",
  "Chave de acesso obrigatória": "Access key is required",
  "Erro ao consultar status na SEFAZ": "Error querying status at SEFAZ",
  "Lista de chaves de acesso é obrigatória": "List of access keys is required",
  "Erro ao apagar NF-e": "Error deleting NF-e",
  "Tipo de evento obrigatório": "Event type is required",
  "Erro ao enviar evento": "Error sending event",
  "Erro ao buscar notas fiscais": "Error fetching invoices",
  "Erro ao buscar itens": "Error fetching items",
  "Erro ao buscar documentos": "Error fetching documents",
  "Dados salvos com sucesso": "Data saved successfully",
  "Erro ao salvar dados": "Error saving data",

  // Motor de continuação de processo
  "Accesskey do item é obrigatória": "Item accesskey is required",
  "Item não encontrado": "Item not found",
  "A etapa atual do item ainda não está concluída": "The item's current step is not completed yet",
  "Erro ao continuar processamento": "Error continuing processing",

  // Criptografia de certificado / infra
  "CERT_ENCRYPTION_KEY inválida — defina 64 caracteres hex (32 bytes) no .env": "Invalid CERT_ENCRYPTION_KEY — set 64 hex characters (32 bytes) in .env",
  "Formato de senha criptografada inválido": "Invalid encrypted password format",
};

const PATTERNS = [
  // accessKey/dados obrigatórios não informados
  [/^accessKey não informada para criar recebimento$/, () => "accessKey not provided to create goods receipt"],
  [/^accessKey não informada para finalização do processo$/, () => "accessKey not provided to finalize the process"],
  [/^accessKey não informada para validação de assinatura$/, () => "accessKey not provided for signature validation"],
  [/^accessKey não informada para atribuição de pedido$/, () => "accessKey not provided for order assignment"],
  [/^accessKey não informada para criar remessa$/, () => "accessKey not provided to create delivery"],
  [/^accessKey não informada para entrada de mercadoria$/, () => "accessKey not provided for goods receipt"],
  [/^accessKey não informada para entrada de fatura$/, () => "accessKey not provided for invoice entry"],
  [/^accessKey não informada para lançamento de fatura$/, () => "accessKey not provided to post the invoice"],
  [/^accessKey não informada para simulação de fatura$/, () => "accessKey not provided for invoice simulation"],
  [/^accessKey não informada para confirmação de quantidade$/, () => "accessKey not provided for quantity confirmation"],
  [/^accessKey da NF-e é obrigatória$/, () => "NF-e accessKey is required"],

  // Erros de conexão/resposta do SAP PI
  [/^Falha na conexão com o SAP PI: ([\s\S]+)$/, (m) => `Connection failure with SAP PI: ${m[1]}`],
  [/^Falha de conexão com PI: ([\s\S]+)$/, (m) => `Connection failure with PI: ${m[1]}`],
  [/^SAP PI retornou erro (.+)$/, (m) => `SAP PI returned error ${m[1]}`],
  [/^Resposta inesperada do PI: ([\s\S]+)$/, (m) => `Unexpected response from PI: ${m[1]}`],
  [/^Resposta inesperada do PI$/, () => "Unexpected response from PI"],
  [/^Resposta fora do formato esperado do PI$/, () => "Unexpected response format from PI"],
  [/^Erro ao consultar depósitos no SAP PI: ([\s\S]+)$/, (m) => `Error querying warehouses on SAP PI: ${m[1]}`],
  [/^Erro ao consultar lotes no SAP PI: ([\s\S]+)$/, (m) => `Error querying batches on SAP PI: ${m[1]}`],
  [/^Erro ao consultar pedido no SAP PI: ([\s\S]+)$/, (m) => `Error querying order on SAP PI: ${m[1]}`],
  [/^Erro ao consultar o SAP PI: ([\s\S]+)$/, (m) => `Error querying SAP PI: ${m[1]}`],

  // Buscas sem resultado
  [/^Nenhum pedido encontrado para os parâmetros informados$/, () => "No order found for the given parameters"],
  [/^Nenhum lote encontrado para os parâmetros informados$/, () => "No batch found for the given parameters"],
  [/^Nenhum item encontrado para esta NF-e$/, () => "No item found for this NF-e"],
  [/^Nenhum item com pedido atribuído encontrado para criar remessa$/, () => "No item with an assigned order found to create the delivery"],

  // Sucesso sem mensagem de retorno do SAP
  [/^Pedido atribuído com sucesso$/, () => "Order assigned successfully"],
  [/^Remessa criada sem mensagens de retorno$/, () => "Delivery created with no return messages"],
  [/^Entrada de mercadoria \(transferência\) criada sem mensagens de retorno$/, () => "Goods receipt (transfer) created with no return messages"],
  [/^Entrada de mercadoria criada sem mensagens de retorno$/, () => "Goods receipt created with no return messages"],
  [/^Quantidade confirmada$/, () => "Quantity confirmed"],

  // Depósito
  [/^Depósito não informado\. Acesse "Entrar Quantidade" para configurar o depósito antes de continuar\.$/, () => 'Warehouse not provided. Go to "Enter Quantity" to set the warehouse before continuing.'],
  [/^Todos os itens precisam ter depósito informado antes de criar a entrada de mercadoria\.$/, () => "All items must have a warehouse set before creating the goods receipt."],

  // NF-e / XML
  [/^NF-e não encontrada: (.+)$/, (m) => `NF-e not found: ${m[1]}`],
  [/^XML não informado no contexto$/, () => "XML not provided in context"],
  [/^Não foi possível obter a chave de acesso do XML$/, () => "Could not get the access key from the XML"],
  [/^XML duplicado — chave já existente na base$/, () => "Duplicate XML — key already exists in the database"],
  [/^XML salvo com sucesso$/, () => "XML saved successfully"],
  [/^XML não encontrado na base para a chave (.+)$/, (m) => `XML not found in the database for key ${m[1]}`],
  [/^CFOP (.+) sem processo configurado$/, (m) => `CFOP ${m[1]} has no process configured`],
  [/^CNPJ destinatário (.+) não cadastrado$/, (m) => `Recipient CNPJ ${m[1]} not registered`],
  [/^CNPJ destinatário (.+) está inativo$/, (m) => `Recipient CNPJ ${m[1]} is inactive`],
  [/^Pedido\/item de pedido não informado no XML para os itens: (.+)\. Atribuição manual necessária\.$/, (m) => `Order/order item not provided in the XML for items: ${m[1]}. Manual assignment required.`],
  [/^Etapa 1 não configurada para o processo (.+)$/, (m) => `Step 1 not configured for process ${m[1]}`],

  // Erros genéricos de persistência (getFriendlyError em saveNfeXml.js)
  [/^Registro duplicado\.$/, () => "Duplicate record."],
  [/^Erro ao salvar XML\.$/, () => "Error saving XML."],
  [/^Falha de vínculo com tabela relacionada\.$/, () => "Failed to link related table."],
  [/^CFOP inválido ou não cadastrado na tabela de referência\.$/, () => "Invalid CFOP or not registered in the reference table."],

  // Assinatura digital
  [/^Nenhuma assinatura encontrada no XML$/, () => "No signature found in the XML"],
  [/^Assinatura inválida$/, () => "Invalid signature"],
  [/^Assinatura digital do XML válida$/, () => "XML digital signature valid"],
  [/^Erro ao validar assinatura: ([\s\S]+)$/, (m) => `Error validating signature: ${m[1]}`],

  // Erros "Erro ao/na/no <ação>: <detalhe>" — um por etapa do processo
  [/^Erro ao finalizar processo: ([\s\S]+)$/, (m) => `Error finishing process: ${m[1]}`],
  [/^Erro na atribuição de pedido: ([\s\S]+)$/, (m) => `Error assigning order: ${m[1]}`],
  [/^Erro ao criar remessa: ([\s\S]+)$/, (m) => `Error creating delivery: ${m[1]}`],
  [/^Erro na entrada de mercadoria: ([\s\S]+)$/, (m) => `Error in goods receipt: ${m[1]}`],
  [/^Erro na entrada de fatura: ([\s\S]+)$/, (m) => `Error in invoice entry: ${m[1]}`],
  [/^Erro no lançamento de fatura: ([\s\S]+)$/, (m) => `Error posting invoice: ${m[1]}`],
  [/^Erro na simulação de fatura: ([\s\S]+)$/, (m) => `Error simulating invoice: ${m[1]}`],
  [/^Erro ao criar recebimento: ([\s\S]+)$/, (m) => `Error creating goods receipt: ${m[1]}`],
  [/^Erro ao dar entrada na mercadoria: ([\s\S]+)$/, (m) => `Error entering goods receipt: ${m[1]}`],

  // Motor de processo (processEngine.js / sapFunctionExecutor.js)
  [/^Processo finalizado com sucesso$/, () => "Process finished successfully"],
  [/^Processo finalizado$/, () => "Process finished"],
  [/^Etapa inativa — ignorada$/, () => "Inactive step — skipped"],
  [/^Sem função configurada$/, () => "No function configured"],
  [/^Etapa (.+) sem função configurada$/, (m) => `Step ${translateDbLabel(m[1], true)} has no function configured`],
  [/^Aguardando processamento manual da etapa: (.+)$/, (m) => `Waiting for manual processing of step: ${translateDbLabel(m[1], true)}`],
  [/^Função '(.+)' não implementada$/, (m) => `Function '${m[1]}' not implemented`],
  [/^Erro inesperado na execução SAP$/, () => "Unexpected error during SAP execution"],

  // SEFAZ (dinâmicas)
  [/^Certificado digital não configurado para CNPJ (.+)$/, (m) => `Digital certificate not configured for CNPJ ${m[1]}`],
  [/^Certificado não configurado para CNPJ (.+)$/, (m) => `Certificate not configured for CNPJ ${m[1]}`],
  [/^UF "(.+)" não possui endpoint mapeado$/, (m) => `State (UF) "${m[1]}" has no mapped endpoint`],
  [/^Erro ao conectar à SEFAZ-(.+): ([\s\S]+)$/, (m) => `Error connecting to SEFAZ-${m[1]}: ${m[2]}`],
  [/^Erro ao conectar à SEFAZ: ([\s\S]+)$/, (m) => `Error connecting to SEFAZ: ${m[1]}`],
  [/^Falha ao descompactar: ([\s\S]+)$/, (m) => `Failed to decompress: ${m[1]}`],
  [/^Tipo de evento inválido: (.+)$/, (m) => `Invalid event type: ${m[1]}`],
  [/^Erro ao ler certificado: ([\s\S]+)$/, (m) => `Error reading certificate: ${m[1]}`],
  [/^Erro ao assinar evento: ([\s\S]+)$/, (m) => `Error signing event: ${m[1]}`],

  // Admin — usuários (dinâmica)
  [/^Seu perfil não pode criar usuários do tipo (.+)$/, (m) => `Your role cannot create users of type ${m[1]}`],

  // Item bloqueado / bapiret2 genérico
  [/^Item bloqueado pelo usuário (.+)$/, (m) => `Item locked by user ${m[1]}`],
];

export function translateBackendMessage(text, isEnglish) {
  if (!isEnglish || !text) return text;
  const source = String(text).trim();

  if (STATIC_MESSAGES[source]) return STATIC_MESSAGES[source];

  for (const [pattern, build] of PATTERNS) {
    const match = source.match(pattern);
    if (match) return build(match);
  }
  return text;
}
